import { Check } from "lucide-react";
import { Reveal } from "../Reveal";
import { SectionHeading } from "./About";
import { WHY_US, IMAGES } from "../../lib/siteData";

export const WhyUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16 lg:px-8">
        <Reveal className="relative order-2 lg:order-1">
          <img
            src={IMAGES.solar}
            alt="Solar energy infrastructure"
            className="h-[420px] w-full rounded-2xl border border-border object-cover grayscale lg:h-[520px]"
            loading="lazy"
          />
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <SectionHeading
              eyebrow="Why Clients Engage Us"
              title="Fewer handoffs. Stronger outcomes. Lower lifecycle OPEX."
            />
          </Reveal>
          <div className="mt-8 space-y-4">
            {WHY_US.map((point, i) => (
              <Reveal
                key={i}
                delay={i * 60}
                data-testid={`why-us-item-${i}`}
                className="flex items-start gap-4 border-b border-border pb-4"
              >
                <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime-bright">
                  <Check className="text-forest" size={14} strokeWidth={3} />
                </div>
                <p className="font-body text-base leading-relaxed text-forest">{point}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
